<template>
    <component :is="currentLayout" />
    <Toast />
    <DynamicDialog />
    <ConfirmPopup group="popup"></ConfirmPopup>
    <ConfirmDialog group="dialog"></ConfirmDialog>
    <div id="popups-container"></div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useKeybindingsExplanation } from "@/composables/keybindings-explanation";

import * as Layouts from "@/layouts";
import { useHtmlTitleManager } from "@/composables/html-title-manager";
import { useHotKeys } from "./composables/hotkeys";

const route = useRoute();
const { attach } = useHotKeys();

attach();
useKeybindingsExplanation();
useHtmlTitleManager();

const currentLayout = computed(() => {
    if (route.meta.layout) {
        if (!(route.meta.layout in Layouts)) {
            throw new Error(`Unknown layout: ${route.meta.layout}`);
        }
        return Layouts[route.meta.layout];
    }
    return Layouts["ApplicationLayout"];
});
</script>

<style scoped>
#navbar-container {
    min-height: 100vh;
    overflow: auto;
}
#popups-container {
    position: absolute;
    z-index: 99;
}
</style>
